/** White-label app pipeline status (stored on `organizations/{id}/settings/whiteLabel.workflowStatus`). */
export type OrganizationWhiteLabelWorkflowStatus =
  | 'pending_information'
  | 'draft'
  | 'pending_store_submission'
  | 'in_store_review'
  | 'live'
  | 'changes_requested';

export interface WhiteLabelWorkflowMeta {
  status: OrganizationWhiteLabelWorkflowStatus;
  /** Ionic badge / chip color */
  color: string;
  labelKey: string;
  descriptionKey: string;
}

export const WHITE_LABEL_WORKFLOW_STATUSES: OrganizationWhiteLabelWorkflowStatus[] = [
  'pending_information',
  'draft',
  'pending_store_submission',
  'in_store_review',
  'live',
  'changes_requested',
];

export const WHITE_LABEL_WORKFLOW_META: WhiteLabelWorkflowMeta[] = [
  {
    status: 'pending_information',
    color: 'warning',
    labelKey: 'workflowPendingInformation',
    descriptionKey: 'workflowPendingInformationDesc',
  },
  {
    status: 'draft',
    color: 'medium',
    labelKey: 'workflowDraft',
    descriptionKey: 'workflowDraftDesc',
  },
  {
    status: 'pending_store_submission',
    color: 'primary',
    labelKey: 'workflowPendingStoreSubmission',
    descriptionKey: 'workflowPendingStoreSubmissionDesc',
  },
  {
    status: 'in_store_review',
    color: 'tertiary',
    labelKey: 'workflowInStoreReview',
    descriptionKey: 'workflowInStoreReviewDesc',
  },
  {
    status: 'live',
    color: 'success',
    labelKey: 'workflowLive',
    descriptionKey: 'workflowLiveDesc',
  },
  {
    status: 'changes_requested',
    color: 'danger',
    labelKey: 'workflowChangesRequested',
    descriptionKey: 'workflowChangesRequestedDesc',
  },
];

const TRAINER_EDITABLE: OrganizationWhiteLabelWorkflowStatus[] = [
  'pending_information',
  'draft',
  'changes_requested',
];

export function normalizeWhiteLabelWorkflowStatus(
  raw?: string | null
): OrganizationWhiteLabelWorkflowStatus {
  if (raw === 'submitted') {
    return 'pending_store_submission';
  }
  if (raw && WHITE_LABEL_WORKFLOW_STATUSES.includes(raw as OrganizationWhiteLabelWorkflowStatus)) {
    return raw as OrganizationWhiteLabelWorkflowStatus;
  }
  return 'pending_information';
}

/** Trainers may edit only before first submission or when admin requests changes. */
export function isWhiteLabelFormEditable(status: OrganizationWhiteLabelWorkflowStatus): boolean {
  return TRAINER_EDITABLE.includes(status);
}

export function getWhiteLabelWorkflowMeta(
  status: OrganizationWhiteLabelWorkflowStatus
): WhiteLabelWorkflowMeta {
  return (
    WHITE_LABEL_WORKFLOW_META.find((m) => m.status === status) ??
    WHITE_LABEL_WORKFLOW_META[0]
  );
}
